var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.canDo('view', 'companies'))?_c('div',[(_vm.adminCompany!=null)?_c('div',[_c('v-list-item',{attrs:{"link":""},on:{"click":_vm.resetCompany}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-account-arrow-left")])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.adminCompany.item.name))])],1)],1):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }